import { IconButton, Tooltip } from "@mui/material";
import Icon from "@mui/material/Icon";
import noImage from "assets/images/no_image.png";
import MDBox from "components/MDBox";
import MDCheckbox from "components/MDCheckbox";
import MDCircularProgress from "components/MDCircularProgress";
import MDTimeTicker from "components/MDTimeTicker";
import MDTypography from "components/MDTypography";
import { Link } from "react-router-dom";
import { numberFormat } from "utility/helpers"; // assuming you have helpers

function ucwords(str) {
  if (str == null) return "";
  return String(str)
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
}
const ListingTableData = ({
  data,
  images = [],
  excelRows = [],
  pagePermission = {},
  handleAddRowToExcel = () => { },
  handleEdit = () => { },
  handleClickOpen = () => { },
  editedColumns = [],
  scrapingStatus = {},
  startScrapingListing = () => { },
  renderAlertSB = null,
  type = "default", // "active" for active listing table
}) => {
  const row = {
    pk: data.id,
    listing_type: (
      <>
        <MDBox display="flex" alignItems="center">
          <MDCheckbox
            checked={excelRows.includes(data.id)}
            sx={{ ml: "7px", mr: "-10px", p: 0 }}
            onChange={() => handleAddRowToExcel(data.id)}
          />
          <MDTypography
            component={Link}
            to={pagePermission.edit ? `/active-listings/edit?id=${data.id}` : ""}
            variant="body2"
            color="info"
          >
            {data.id}
          </MDTypography>
        </MDBox>
        <small
          style={{
            marginLeft: "0px",
            color: data.listing_type === "New" ? "blue" : "inherit",
          }}
        >
          {ucwords(data.listing_type)}
        </small>
      </>
    ),
    listing_id: (
      <>
        <MDTypography
          component={Link}
          to={data.listing_url}
          variant="body2"
          color="info"
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.listing_id}
          <br />
        </MDTypography>
        <small>{ucwords(data.source)}</small>
      </>
    ),
    title: (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <Tooltip
          title={
            <img
              src={images[0] ? images[0] : noImage}
              alt="Preview"
              style={{
                maxWidth: "300px",
                maxHeight: "300px",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                display: "block",
              }}
            />
          }
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "transparent !important",
                padding: 0,
                minWidth: 0,
                maxWidth: "none",
              },
            },
          }}
        >
          <MDBox
            sx={{
              width: { xs: 40, sm: 50 },
              height: { xs: 40, sm: 50 },
              borderRadius: "50%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <img
              src={images[0] ? images[0] : noImage}
              alt="Avatar"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </MDBox>
        </Tooltip>
        <MDTypography ml={1} width="85%" variant="body2">
          {data.title}
        </MDTypography>
      </MDBox>
    ),
    price: (
      <MDTypography display="block" variant="body2" fontWeight="bold">
        {numberFormat(data.price, true)}
      </MDTypography>
    ),
    avg_price: (
      <MDTypography display="block" variant="body2">
        {numberFormat(data.avg_price, true)}
      </MDTypography>
    ),
    category: (
      <MDTypography display="block" variant="body2">
        {data.category}
      </MDTypography>
    ),
    gender: (
      <MDTypography
        display="block"
        whiteSpace="pre-line"
        variant="body2"
        color={editedColumns.includes("gender") ? "success" : ""}
      >
        {data.gender && data.gender.trim() !== "" ? (
          editedColumns.includes("gender") ? (
            <Tooltip
              title={
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => handleEdit(data, data.id)}
                >
                  <Icon>edit</Icon>
                </IconButton>
              }
              placement="top"
            >
              <span>{data.gender}</span>
            </Tooltip>
          ) : (
            <>
              {(data.male + data.female + data.male_calf + data.female_calf + data.unsexed_calf != data.qty) ? (
                <>
                  <MDTypography
                    variant="subtitle"
                    color="error"
                  >{data.gender}</MDTypography>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleEdit(data, data.id)}
                  >
                    <Icon>edit</Icon>
                  </IconButton></>) : data.gender
              }
            </>
          )
        ) : (
          <IconButton
            size="small"
            color="primary"
            onClick={() => handleEdit(data, data.id)}
          >
            <Icon>edit</Icon>
          </IconButton>
        )}
      </MDTypography >
    ),
    reserve_status: (
      <MDTypography display="block" style={{ whiteSpace: "nowrap" }} variant="body2">
        {data.reserve_status}
      </MDTypography>
    ),
    end_date: (
      <>
        <MDTypography display="block" style={{ whiteSpace: "nowrap" }} variant="body2" color="error">
          <MDTimeTicker endDateTime={data.end_date} />
        </MDTypography>
        <small style={{ whiteSpace: "nowrap" }}>{data.end_date}</small>
      </>
    ),
    action: (
      <MDBox display="flex">
        {type === "active" && (
          <>
            {scrapingStatus?.listings?.includes(data.id) ? (
              <MDCircularProgress
                sx={{ mt: 1, mr: 0.75 }}
                color="success"
                title="Scraping is in progress"
                size={20}
              />
            ) : (
              <MDTypography
                mr={0.75}
                mt={1}
                component={Link}
                onClick={() => startScrapingListing(data.id)}
                title={`Start Scraping. Last updated on: ${data.updated_at || data.created_at} UTC`}
                display="block"
                variant="body2"
                color="success"
              >
                <Icon fontSize="small">travel_explore_icon</Icon>
              </MDTypography>
            )}
          </>
        )}
        {pagePermission.edit && (
          <MDTypography
            mr={0.5}
            mt={1}
            component={Link}
            to={`/active-listings/edit?id=${data.id}`}
            title="Edit"
            display="block"
            variant="body2"
            color="info"
          >
            <Icon fontSize="small">edit</Icon>
          </MDTypography>
        )}
        {pagePermission.remove && (
          <MDTypography
            mt={1}
            component={Link}
            onClick={() => handleClickOpen(data.id)}
            title="Remove"
            display="block"
            variant="body2"
            color="error"
          >
            <Icon fontSize="small">delete</Icon>
          </MDTypography>
        )}
        {renderAlertSB}
      </MDBox>
    ),
  };

  return row;
};

export default ListingTableData;
